import { Accordion, AccordionSummary, ListItemText, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Styled } from "./styles";

const Label = () => {
    return (
        <Accordion disableGutters>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel4-content"
                id="panel4-header"
            >
                What should be added on physical label?
            </AccordionSummary>
            <Styled.AccordionDetails>
                <Typography variant="body2">
                    After 8 December 2023, all wine produced and labeled after that date must
                    include:
                </Typography>
                <Styled.OrderedList>
                    <Styled.ListItem>
                        <ListItemText primary="Allergen" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Energy" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="List of ingredients" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText
                            primary="
                            Nutrition information per 100ml"
                        />
                    </Styled.ListItem>
                </Styled.OrderedList>
                <Typography variant="body2">
                    Energy value and allergenic ingredients (1&2) must be on the physical label, but
                    the rest (3&4) of the information is allowed to be fully posted on the digital
                    label.
                </Typography>
                <Typography variant="body2">
                    In such a case, the physical label must contain the energy value expressed per
                    100 ml. To simplify the format and to identify energy content information, the
                    symbol "E" will be used. Information should be presented in both kilojoules and
                    kilocalories.
                </Typography>
                <Typography variant="body2">
                    Below is an example of how the energy indicator should look on your physical
                    label:
                </Typography>
                <Typography variant="body2">For 100ml: E= ### kJ / ## kCAL</Typography>
                <Typography variant="body2">
                    ("#" will be replaced with numbers) Below it, there should be a text that
                    indicates to the user that after scanning the QR code, he can get detailed
                    information about the product.
                </Typography>
                <Typography variant="body2">
                    Any ingredients that potentially cause allergies or food intolerances must also
                    be identified on the physical label. (It is not necessary to list the substances
                    that are lost during production and are not found in the final product - wine)
                </Typography>
            </Styled.AccordionDetails>
        </Accordion>
    );
};

export default Label;
